export default __webpack_public_path__ + "static/media/Lora-MediumItalic.fb722d00.ttf";